"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockTopGallerySagas = void 0;
var effects_1 = require("redux-saga/effects");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var BlockTopGalleryAction_1 = require("@/pages/place/actions/BlockTopGalleryAction");
var BlockTopGalleryApi_1 = require("@/pages/place/sagas/BlockTopGalleryApi");
var PlaceAction_1 = require("@/pages/place/actions/PlaceAction");
var PlaceState_1 = require("@/pages/place/states/PlaceState");
var GoogleMap_1 = require("@/api/vendor/GoogleMap");
var getCurrentIndex = function (state) { return state.place.galleryIndex; };
var getGalleryCount = function (state) { return state.place.galleryItems ? state.place.galleryItems.length : 0; };
var watchInitGallerySaga = function () {
    var currentIndex, galleryCount;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!window)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentIndex)];
            case 2:
                currentIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getGalleryCount)];
            case 3:
                galleryCount = _a.sent();
                if (!(galleryCount > 0)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(BlockTopGalleryAction_1.default.setCurrentIndex(currentIndex, true))];
            case 4:
                _a.sent();
                return [3 /*break*/, 8];
            case 5: return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_SET_MAP_READY)];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setGalleryIndex(-1))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
};
var watchSetGalleryIndexSaga = function () {
    var payload, index, total, noSmooth;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(BlockTopGalleryAction_1.default.BLOCK_TOP_GALLERY_SET_CURRENT_INDEX)];
            case 1:
                payload = (_a.sent()).payload;
                index = payload.index;
                return [4 /*yield*/, effects_1.select(getGalleryCount)];
            case 2:
                total = _a.sent();
                noSmooth = payload.noSmooth;
                return [4 /*yield*/, effects_1.call(BlockTopGalleryApi_1.setBlockTopGalleryScroll, index, total, noSmooth)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchGalleryScrollSaga = function () {
    var scrollListener, galleryCount, index;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!window)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(BlockTopGalleryApi_1.topBlockGalleryScrollListener)];
            case 2:
                scrollListener = _a.sent();
                return [4 /*yield*/, effects_1.select(getGalleryCount)];
            case 3:
                galleryCount = _a.sent();
                _a.label = 4;
            case 4:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(scrollListener)];
            case 5:
                index = (_a.sent()).index;
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setGalleryIndex(index === galleryCount ? -1 : index))];
            case 6:
                _a.sent();
                return [3 /*break*/, 4];
            case 7: return [2 /*return*/];
        }
    });
};
var watchGalleryMapSaga = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_GOOGLE_MAP_READY)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setGoogleMapReady(true))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchGalleryMapClickedSaga = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_ON_GALLERY_MAP_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.showPop(PlaceState_1.GalleryPopState.MAP))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setMapType(GoogleMap_1.GoogleMapType.ROADMAP))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchSetTopGalleryScrollSaga = function () {
    var payload, index, galleryCount;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_SET_TOP_GALLERY_SCROLL)];
            case 1:
                payload = (_a.sent()).payload;
                index = payload;
                return [4 /*yield*/, effects_1.select(getGalleryCount)];
            case 2:
                galleryCount = _a.sent();
                return [4 /*yield*/, effects_1.call(BlockTopGalleryApi_1.setBlockTopGalleryScroll, index, galleryCount)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var blockTopGallerySagas = {
    watchInitGallerySaga: watchInitGallerySaga,
    watchSetGalleryIndexSaga: watchSetGalleryIndexSaga,
    watchGalleryScrollSaga: watchGalleryScrollSaga,
    watchGalleryMapSaga: watchGalleryMapSaga,
    watchGalleryMapClickedSaga: watchGalleryMapClickedSaga,
    watchSetTopGalleryScrollSaga: watchSetTopGalleryScrollSaga,
};
exports.blockTopGallerySagas = blockTopGallerySagas;
